export class CommentPositionNotFoundError extends Error {
  public constructor(
    msg: string,
    public readonly commentId: string,
  ) {
    super(msg);
    this.commentId = commentId;
    Object.setPrototypeOf(this, CommentPositionNotFoundError.prototype);
  }
}
